// eslint-disable-next-line jira/filename-case
import { useProductName } from '@atlassian/jira-tenant-context-controller/src/components/product-name/index.tsx';
import type { Product } from '@atlassian/expansion-services/services';

export const useJiraCurrentProduct = (): Product => {
	const productName = useProductName();
	switch (productName) {
		case 'core':
			return 'jira-core';
		case 'jira':
			return 'jira-software';
		case 'serviceDesk':
			return 'jira-servicedesk';
		case 'product-discovery':
			return 'jira-product-discovery';
		default:
			return 'jira-core';
	}
};
